import { useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const CursorGlow = () => {
  const x = useMotionValue(-600);
  const y = useMotionValue(-600);
  const sx = useSpring(x, { stiffness: 50, damping: 20, mass: 0.8 });
  const sy = useSpring(y, { stiffness: 50, damping: 20, mass: 0.8 });

  useEffect(() => {
    const move = (e) => {
      x.set(e.clientX - 300);
      y.set(e.clientY - 300);
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  return (
    <motion.div
      aria-hidden
      className="pointer-events-none fixed left-0 top-0 z-10 hidden h-[600px] w-[600px] rounded-full md:block"
      style={{
        x: sx,
        y: sy,
        background:
          "radial-gradient(circle, rgba(255,59,218,0.13) 0%, rgba(177,17,255,0.07) 35%, rgba(43,250,255,0.04) 55%, transparent 70%)",
      }}
    />
  );
};

export default CursorGlow;
